import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import React from "react";
import { useNavigate } from "react-router-dom"

const Hero = () => {

  const navigate = useNavigate()

  return (
    <div
      className="flex flex-column justify-content-center align-items-center md:py-8 py-6 px-4 w-full"
      style={{ backgroundColor: "#EA088B" }}
    >
      <h2 className="text-center text-white text-5xl ">Trace your product</h2>
      <p className="text-center text-white text-lg  ">
        Trace your product by entering the batch number to find out the current
        status
      </p>
      <div className="flex md:flex-row flex-column gap-3 md:w-9 w-full md:px-8">
        <span className="p-input-icon-left w-full">
          <i className="pi pi-search text-white" />
          <InputText
            placeholder="Enter Product Batch number"
            style={{ backgroundColor: "rgba(0, 0, 0, 0.16)", color: "white" }}
            className="w-full track-search"
          />
        </span>
        <Button label="Track" className="bg-white text-primary-500"
          onClick={() => navigate("/tracking/12")}
        />
      </div>
    </div>
  );
};

export default Hero;
